export const signupFlowStep = {
  aboutCompany: 1,
  companyGoals: 2,
  slack: 3,
  summary: 4,
} as const;

/** Steps shown in the progress strip; the summary counts as the last one. */
export const SIGN_UP_FLOW_STEPS = signupFlowStep.summary;

/**
 * Maps the persisted onboarding step to the rendered one.
 *
 * The backend stores the step number on the company, so accounts that started
 * signup before the flow was cut down still carry the old seven-step values:
 * 3 careers page, 4 sourcing progress, 5 sourcing results, 6 Slack, 7 summary.
 * Those screens no longer exist, so without this mapping such users would hit
 * "Invalid step". The new flow never persists a value above 4, which makes
 * 5–7 unambiguous legacy values; a legacy 4 collides with the new summary and
 * lands there (those users can still connect Slack from Integrations).
 */
export const getSignupFlowStep = (persistedStep: number) => {
  if (persistedStep === 7) return signupFlowStep.summary;
  if (persistedStep === 5 || persistedStep === 6) return signupFlowStep.slack;
  return persistedStep;
};
